/**
 * Firebase init — newone-f340f (RobinhoodSpace).
 * Web client keys are public; also available from Hosting /__/firebase/init.json
 */
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

/** Default project: newone-f340f (RobinhoodSpace) */
const DEFAULT_WEB_CONFIG = {
  apiKey: 'AIzaSyBmCiMaoZWOvvbV1OUjvIuwWiCgGbv_CWE',
  authDomain: 'newone-f340f.firebaseapp.com',
  projectId: 'newone-f340f',
  storageBucket: 'newone-f340f.firebasestorage.app',
  messagingSenderId: '994246878779',
  appId: '1:994246878779:web:d5a1deeb6608fddacb9e1e',
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || DEFAULT_WEB_CONFIG.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || DEFAULT_WEB_CONFIG.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || DEFAULT_WEB_CONFIG.projectId,
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || DEFAULT_WEB_CONFIG.storageBucket,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || DEFAULT_WEB_CONFIG.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || DEFAULT_WEB_CONFIG.appId,
};

export const hasConfig = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

let app = null;
let db = null;
let auth = null;

if (hasConfig) {
  try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
  } catch (err) {
    console.error('Firebase init failed:', err);
  }
}

export { db, auth, app };
